import { createStore } from "vuex"

import Auth from './modules/Auth'
import Message from './modules/Message'
import Loading from './modules/Loading'

import TicketList from './modules/TicketList'
import Venue from './modules/Venue'
import QrCode from './modules/QrCode'
import Receive from './modules/Receive'
import Distribute from './modules/Distribute'
import ChangeSeat from './modules/ChangeSeat'

import Resale from './modules/Resale'
import LpHistory from './modules/LpHistory'
import Nav from './modules/Nav'
import RouteParams from './modules/RouteParams'

export default createStore({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    Auth,
    Message,
    Loading,
    TicketList,
    Venue,
    QrCode,
    Receive,
    Resale,
    Distribute,
    ChangeSeat,
    LpHistory,
    Nav,
    RouteParams
  },
  mutations: {
    // stateを置き換えます。
    load(state, store) {
      this.replaceState(Object.assign(state, store))
    }
  }
})
